<template>
  <a
    v-if="url"
    v-tooltip="tooltipConfig"
    :href="url"
    :target="target"
    :class="$style.link"
    @click="trackClick"
    >help_outlined</a
  >
</template>

<script>
import { toTooltipConfig } from '@/helpers/tooltip-helpers';

export default {
  props: {
    url: {
      type: String,
      required: true,
    },
    tooltip: {
      type: [String, Object],
    },
    target: {
      type: String,
      default: '_blank',
    },
  },
  computed: {
    tooltipConfig() {
      if (!this.tooltip) return;
      return {
        offset: [0, 10],
        ...toTooltipConfig(this.tooltip),
      };
    },
  },
  methods: {
    trackClick() {
      this.$track('click:help-link', {
        url: this.url,
        tooltip: this.tooltipConfig?.content,
      });
    },
    preventDefault(e) {
      e.preventDefault();
    },
  },
};
</script>

<style module>
.link {
  display: inline-block;
  width: 1em;
  vertical-align: bottom;
  font-family: 'Material Icons Outlined';
  font-weight: normal;
  font-style: normal;
  letter-spacing: normal;
  text-transform: none;
  white-space: nowrap;
  overflow-wrap: normal;
  text-decoration: none;
  color: var(--neutral-600);
  cursor: pointer;

  &:hover {
    color: var(--amber-600);
  }
}
</style>
